//GR1 -- Do not remove comment
import pastelCandy from './PastelCandy';
import normal from './Normal';

const themes = {
    //GR2 -- Do not remove comment
    normal,
    pastelCandy,
};

export default function getTheme(theme) {
    return themes[theme];
}